<template>
  <section id="projects">
    <h2 class="numbered-heading">Some Things I've Built</h2>
    <div>
      <div
        v-for="p in projects"
        :key="p.id"
        class="featured-projects">
        <div class="project-content">
          <p class="project-overline">Featured Project</p>
          <h3
            class="project-title"
            @click.prevent="gotoProjectDetails(p.id,)">{{ p.name }}</h3>
          <div class="project-description">
            <p>
              {{ p.description }}
            </p>
          </div>
          <ul class="project-tech-list">
            <li
              v-for="lang in p.languages"
              :key="p.id+'-'+lang">{{ lang }}</li>
          </ul>
          <div class="project-links">
            <a
              v-if="!p.links.github"
              href="javascript:void(0)"
              aria-label="Github Link"
              title="Open project in github"
            >
              <font-awesome-icon
                :icon="['fab', 'github',]"
                role="presentation" />
            </a>
            <a
              v-else
              :href="p.links.github"
              aria-label="Github link"
              target="_blank"
              rel="noopener noreferrer"
              title="Open project in github"
            >
              <font-awesome-icon
                :icon="['fab', 'github',]"
                role="presentation" />
            </a>
            <a
              :href="p.links.live"
              aria-label="Live Site link"
              target="_blank"
              rel="noopener noreferrer"
              title="Open live site"
            >
              <font-awesome-icon
                icon="link"
                role="presentation" />
            </a>
          </div>
        </div>
        <div class="project-image">
          <a
            href="#"
            @click.prevent="gotoProjectDetails(p.id,)">
            <div class="img img-wrapper">
              <img
                :src="p.image.src"
                :alt="p.image.alt" />
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SampleProjects',
  data () {
    return {
      projects: [
        {
          id: 'levi',
          name: 'Levi\'s Ecommerce',
          description: 'Levi Strauss & Co. is an American clothing company known worldwide for its Levi\'s brand of denim jeans. It was founded in May 1853 when German immigrant Levi Strauss moved from Buttenheim, Bavaria, to San Francisco, California, to open a west coast branch of his brothers\' New York dry goods business.',
          image: {
            src: '/images/projects/levi/levi.png',
            alt: 'Levi\'s Ecommerce'
          },
          links: {
            github: null,
            live: 'https://www.levi.com/US/en_US'
          },
          languages: [
            'Vue js', 'Node', 'GraphQL', 'Redis'
          ]
        },
        {
          id: 'gintaav3',
          name: 'Gintaa',
          description: 'With years of research and strict deadlines, our computer geniuses are ready with a unique concept where you can “give and take anything”. It is the one-stop destination for every dreamer, who wants to establish their business or merely get amazing products/services for incredible offers.',
          image: {
            src: '/images/projects/gintaav3/gintaav3.png',
            alt: 'Gintaa'
          },
          links: {
            github: null,
            live: 'https://www.gintaa.com'
          },
          languages: [
            'Angular 8', 'Material', 'Firebase', 'SSR'
          ]
        },
        {
          id: 'lilly',
          name: 'Lilly India',
          description: 'Since its inception in India in 1993, Eli Lilly and Company (India) Pvt. Ltd. has been committed to developing and marketing pharmaceutical products to treat diabetes, gastric cancer, lung cancer, osteoporosis, rheumatoid arthritis, men\'s health and growth-hormone deficiency. Lilly India affiliate also comprises operations in neighboring countries of Nepal, Bangladesh and Sri Lanka.',
          image: {
            src: '/images/projects/lilly/lilly.png',
            alt: 'Lilly India'
          },
          links: {
            github: null,
            live: 'https://www.lillyindia.co.in/'
          },
          languages: [
            'Node', 'Koa', 'Vue JS', 'Heroku', 'Postgres'
          ]
        },
        {
          id: 'bitclude',
          name: 'BitClude.com',
          description: 'BitClude is a Bitcoin exchange available 24/7, to all registered users. It only takes 3 minutes to register and verify your identity with a simple ID, and with this simple procedure you will always be able to buy Bitcoins!',
          image: {
            src: '/images/projects/bitclude/bitclude1.png',
            alt: 'BitClude'
          },
          links: {
            github: null,
            live: 'https://bitclude.com/en/'
          },
          languages: [
            'Node', 'Blockchain', 'Redis', 'MongoDB'
          ]
        },
        {
          id: 'bitmarket',
          name: 'Bitmarket.pl',
          description: 'BitMarket is the first cryptocurrency exchange in Poland. From 2013, she spread the idea of ​​Satoshi Nakamoto, enabling Poles to learn about a modern approach to the world of finance. BitMarket gave everyone a chance to check the bitcoin rate and buy it at the best price.',
          image: {
            src: '/images/projects/bitmarket1.png',
            alt: 'Bitmarket'
          },
          links: {
            github: null,
            live: 'https://bitmarket.pl/'
          },
          languages: [
            'PHP', 'Node', 'Blockchain', 'Redis', 'Memcached'
          ]
        }
      ]
    }
  },
  methods: {
    gotoProjectDetails (project) {
      if (project === 'bitmarket') {
        return
      }
      this.$router.push('/details/' + project)
    }
  }
}
</script>

<style scoped>
</style>
